import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import LegalPage from "@/components/LegalPage";
import AuthCallback from "@/components/AuthCallback";

// Google sign-in returns to {origin}/#session_id=... — must be detected synchronously during render
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" title="Privacy Policy" />} />
      <Route path="/terms-of-service" element={<LegalPage slug="terms-of-service" title="Terms of Service" />} />
      <Route path="*" element={<App />} />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  </React.StrictMode>,
);
